'use client';

import Link from 'next/link';

export default function ProductError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="bg-slate-50">
      <div className="mx-auto w-full max-w-[1440px] px-3 pb-10 pt-5 sm:px-6 sm:pt-6 lg:px-8">
        <div className="mx-auto max-w-xl rounded-lg border border-slate-200 bg-white p-8 text-center">
          <h1 className="text-2xl font-semibold tracking-tight text-slate-950">
            Something went wrong
          </h1>
          <p className="mt-2 text-sm text-slate-600 sm:text-base">
            We couldn&apos;t load this product. It may have been moved or there was a temporary error.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <button
              onClick={reset}
              className="inline-flex min-h-11 items-center justify-center rounded-md bg-blue-700 px-4 text-sm font-semibold text-white hover:bg-blue-800"
            >
              Try again
            </button>
            <Link
              href="/browse"
              className="inline-flex min-h-11 items-center justify-center rounded-md border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-800 hover:bg-slate-50"
            >
              Browse products
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
